// OdemeSayfasi.tsx (GÜNCELLENMİŞ VERSİYON)
import React, { useState, useEffect } from 'react';
import { Button } from 'components/ui/button';
import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SimpleHeader from 'components/SimpleHeader';
import { OrderSummaryCard } from 'components/OrderSummaryCard';
import { OrderDetailsForDisplay, ShippingDetails } from 'types/order.types';
import { PRODUCTS, MASA_KARTI_TASARIMLARI, EL_KARTI_TASARIMLARI, TEK_YUZ_MASA_KARTI_TASARIMLARI, PACKAGE_CATEGORIES } from '../data/packages';
import { startPaymentProcess, validateCoupon } from '../services/apiService';
import { getCustomMasaKartiUnitPrice } from './BaskiPage';

// ─── Sözleşme İçerikleri ────────────────────────────────────────────────
const LEGAL_CONTENTS: Record<string, React.ReactNode> = {
  '/mesafeli-satis': (
    <div className="space-y-6 text-sm text-neutral-800 leading-relaxed">
      <h2 className="text-base font-bold">MADDE 1 – TARAFLAR</h2>
      <div>
        <h3 className="font-semibold mb-1">1.1. SATICI BİLGİLERİ</h3>
        <p className="font-medium">Unvanı: ANORA FOREVER YAZILIM VE REKLAM ORGANİZASYON LİMİTED ŞİRKETİ</p>
        <ul className="list-disc list-inside pl-2 mt-1 space-y-0.5">
          <li>Adres: SULTAN SELİM MAH. ESKİ BÜYÜKDERE CAD. NO: 61 İÇ KAPI NO: 2 KAĞITHANE/İSTANBUL</li>
          <li>Telefon: +90 554 698 31 44</li>
          <li>E-posta: info@anoraforever.com</li>
          <li>Mersis No: 0070123001700001</li>
          <li>Vergi Dairesi/No: MASLAK/701230017</li>
        </ul>
      </div>
      <div>
        <h3 className="font-semibold mb-1">1.2. ALICI BİLGİLERİ</h3>
        <p className="italic border-l-2 border-neutral-300 pl-3">Alıcı; adı, soyadı, telefon numarası, e-posta bilgileri ve fatura/teslimat adresi ile siparişin verildiği esnada bildirdiği kişi/kurumdur.</p>
      </div>
      <div>
        <h2 className="text-base font-bold">MADDE 2 – SÖZLEŞME KONUSU HİZMET</h2>
        <p className="mt-1">İşbu Sözleşme'nin konusu, Alıcı'nın Satıcı'ya ait internet sitesinden elektronik ortamda siparişini verdiği dijital hizmetin satışı ve teslimi ile ilgili tarafların hak ve yükümlülüklerini düzenlemesidir.</p>
      </div>
      <div>
        <h2 className="text-base font-bold">MADDE 3 – FİYAT</h2>
        <ul className="list-disc list-inside pl-2 space-y-0.5">
          <li>Hizmetin Tanımı: Anora Forever Dijital Etkinlik Albümü</li>
          <li>KDV Dahil Satış Fiyatı: Sipariş özetinde belirtilen tutardır.</li>
          <li>Ödeme Şekli: Kredi Kartı / Banka Havalesi</li>
        </ul>
      </div>
      <div>
        <h2 className="text-base font-bold">MADDE 4 – CAYMA HAKKI İSTİSNASI</h2>
        <p className="font-semibold">Alıcı'nın Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi uyarınca cayma hakkı bulunmamaktadır.</p>
        <p className="mt-1 italic">Anora Forever hizmetleri, ödeme sonrası anında ifa edilen dijital hizmet kapsamında olduğundan Alıcı cayma hakkını kullanamayacağını kabul eder.</p>
      </div>
      <div>
        <h2 className="text-base font-bold">MADDE 5 – GENEL HÜKÜMLER</h2>
        <ul className="list-disc list-inside pl-2 space-y-0.5">
          <li>Alıcı, hizmetin temel nitelikleri ve satış fiyatı hakkında bilgi sahibi olduğunu kabul eder.</li>
          <li>Hizmetin ifası, ödemenin başarıyla tamamlanmasıyla anında gerçekleşir.</li>
        </ul>
      </div>
      <div>
        <h2 className="text-base font-bold">MADDE 6 – YETKİLİ MAHKEME</h2>
        <p>Uyuşmazlıklarda Alıcı'nın yerleşim yerindeki Tüketici Hakem Heyetleri veya Tüketici Mahkemeleri yetkilidir.</p>
      </div>
    </div>
  ),
  '/kosullar': (
    <div className="space-y-5 text-sm text-neutral-800 leading-relaxed">
      <div><h2 className="text-base font-bold mb-1">1. Giriş</h2><p>Bu Kullanım Koşulları, Anora Forever Yazılım ve Reklam Organizasyon Limited Şirketi tarafından sunulan anoraforever.com platformunun kullanımını düzenler.</p></div>
      <div><h2 className="text-base font-bold mb-1">2. Hizmetlerin Kullanımı</h2><p>Platformu yalnızca yasal amaçlarla ve bu koşullara uygun olarak kullanmayı kabul edersiniz. Yasa dışı, hileli veya kötü niyetli amaçlarla kullanım yasaktır.</p></div>
      <div><h2 className="text-base font-bold mb-1">3. Hesap Güvenliği</h2><p>Hesabınız altında gerçekleşen tüm faaliyetlerden siz sorumlusunuz. Şifrenizi gizli tutun.</p></div>
      <div>
        <h2 className="text-base font-bold mb-1">4. Kullanıcı İçerikleri ve Sorumluluk</h2>
        <p>Platforma yüklediğiniz tüm içeriklerin sorumluluğu size aittir.</p>
        <p className="mt-2">Anora Forever, sadece bir teknik altyapı sağlayıcısıdır. Etkinliğe katılan davetlilerin, görüntülerin sisteme yüklenmesi hususunda bilgilendirilmesi ve gerekli rızalarının alınması tamamen Etkinlik Sahibi'nin sorumluluğundadır. Etkinlik Sahibi, platformu kullanarak davetlilerine bu aydınlatmanın yapıldığını beyan ve taahhüt eder. Üçüncü şahıslardan gelebilecek veri gizliliği veya telif itirazlarında Anora Forever'ın hiçbir hukuki sorumluluğu bulunmamaktadır.</p>
      </div>
      <div><h2 className="text-base font-bold mb-1">5. Ücretlendirme</h2><p>Platformda sunulan hizmetler ücretlidir. Yapılan ödemeler genellikle iade edilmez.</p></div>
      <div><h2 className="text-base font-bold mb-1">6. Fikri Mülkiyet</h2><p>Platformdaki tüm materyaller Şirketimizin mülkiyetindedir ve fikri mülkiyet yasalarıyla korunmaktadır.</p></div>
      <div><h2 className="text-base font-bold mb-1">7. Sorumluluk Reddi</h2><p>Hizmetler "olduğu gibi" sunulmaktadır. Şirketimiz kesintisiz hizmet garantisi vermez.</p></div>
      <div><h2 className="text-base font-bold mb-1">8. İletişim</h2><p>Şirket: ANORA FOREVER YAZILIM VE REKLAM ORGANİZASYON LİMİTED ŞİRKETİ<br/>E-posta: info@anoraforever.com</p></div>
    </div>
  ),
  '/gizlilik-politikasi': (
    <div className="space-y-5 text-sm text-neutral-800 leading-relaxed">
      <div><h2 className="text-base font-bold mb-1">Giriş</h2><p>Anora Forever, kullanıcılarımızın gizliliğine büyük önem vermektedir. Bu politika, anoraforever.com için geçerlidir.</p></div>
      <div><h2 className="text-base font-bold mb-1">1. Hangi Verileri Topluyoruz?</h2><ul className="list-disc list-inside pl-2 space-y-0.5"><li><strong>İsim ve E-posta:</strong> Hesap oluşturma ve iletişim için.</li><li><strong>Yüklenen İçerikler:</strong> Galeriyi oluşturmak amacıyla fotoğraf ve videolar.</li><li><strong>Teknik Veriler:</strong> IP adresi, tarayıcı türü (güvenlik için).</li></ul><p className="mt-2"><strong>Toplamadığımız:</strong> Kredi kartı numarası, CVV gibi hassas finansal bilgiler asla saklanmaz.</p></div>
      <div><h2 className="text-base font-bold mb-1">2. Kullanım Amacı ve Saklama Süresi</h2><p>Veriler hizmet sunumu, iletişim ve güvenlik amaçlıdır. İçerikler paket süresince saklanır, süre bitiminde silinir.</p></div>
      <div><h2 className="text-base font-bold mb-1">3. Verilerin Paylaşımı</h2><p>Kişisel verileriniz izniniz olmadan üçüncü taraflarla paylaşılmaz. Yalnızca hizmet için zorunlu iş ortakları (bulut, veritabanı, ödeme) ile paylaşılır.</p></div>
      <div><h2 className="text-base font-bold mb-1">4. Veri Güvenliği</h2><p>Veriler Cloudflare ve MongoDB Atlas üzerinde şifrelenerek saklanır. Sistemi sağlıklı çalıştırmak amacıyla yalnızca yetkilendirilmiş Anora Forever teknik personeli sınırlı ve denetimli erişim sağlayabilir. Bu erişim, içeriklerin reklam veya ticari amaçla kullanılması anlamına gelmez.</p></div>
      <div><h2 className="text-base font-bold mb-1">5. Kullanıcı Hakları</h2><ul className="list-disc list-inside pl-2 space-y-0.5"><li>Verilerinize erişme ve kopyasını talep etme</li><li>Yanlış verilerin düzeltilmesini isteme</li><li>Verilerinizin silinmesini isteme</li></ul><p className="mt-1">Talepler için: <strong>info@anoraforever.com</strong></p></div>
      <div><h2 className="text-base font-bold mb-1">6. Çerezler</h2><p>Oturum yönetimi için zorunlu çerezler ve anonim analiz çerezleri kullanılır.</p></div>
    </div>
  ),
};

// --- Sayfa içi sözleşme modal ---
function LegalModal({ path, title, onClose }: { path: string; title: string; onClose: () => void }) {
  const content = LEGAL_CONTENTS[path];

  // Body scroll kapat
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm p-0 sm:p-4"
      onClick={onClose}
    >
      <div
        className="relative w-full sm:max-w-2xl bg-white rounded-t-3xl sm:rounded-2xl shadow-2xl flex flex-col"
        style={{ maxHeight: '90vh' }}
        onClick={e => e.stopPropagation()}
      >
        {/* Başlık */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 flex-shrink-0">
          <h3 className="font-bold text-gray-800 text-base pr-4">{title}</h3>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full hover:bg-gray-100 text-gray-500 transition-colors flex-shrink-0"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* İçerik — doğrudan render */}
        <div className="flex-1 overflow-y-auto px-6 py-5">
          {content ?? <p className="text-gray-500 text-sm">İçerik yüklenemedi.</p>}
        </div>

        {/* Kapat butonu */}
        <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-xl bg-rose-50 text-rose-600 font-semibold hover:bg-rose-100 transition-colors"
          >
            Okudum, Kapat
          </button>
        </div>
      </div>
    </div>
  );
}

// TypeScript tipi tanımı
type PaymentMethod = 'bank_transfer' | 'card';

// 💳 HAVALE BİLGİLERİNİ BURADAN YÖNET
const BANK_TRANSFER_INFO = {
  bankName: 'Garanti BBVA',
  accountName: 'ANORA FOREVER YAZILIM VE REKLAM ORGANİZASYON LİMİTED ŞİRKETİ',
  iban: 'TR73 0006 2000 7210 0006 2913 93',
  explanationNote: 'Açıklamaya sipariş numaranızı eklemeyi unutmayınız.',
};

const getDesignDetails = (productId: string, designId: string | undefined) => {
  if (productId === 'masa-karti' && designId) {
    const design = MASA_KARTI_TASARIMLARI.find((d) => d.id === designId);
    return {
      imageUrl: design?.productImageUrl || '',
      designName: design?.name,
    };
  }
  if (productId === 'tek-yuz-masa-karti' && designId) {
    const design = TEK_YUZ_MASA_KARTI_TASARIMLARI.find((d) => d.id === designId);
    return {
      imageUrl: design?.productImageUrl || '',
      designName: design?.name,
    };
  }
  if (productId === 'el-karti' && designId) {
    const design = EL_KARTI_TASARIMLARI.find((d) => d.id === designId);
    return {
      imageUrl: design?.productImageUrl || '',
      designName: design?.name,
    };
  }
  return {
    imageUrl: PRODUCTS.find((p) => p.id === productId)?.imageUrl || '',
    designName: undefined,
  };
};

export default function OdemeSayfasi() {
  const navigate = useNavigate();

  const [orderDetails, setOrderDetails] = useState<OrderDetailsForDisplay | null>(null);
  const [shippingDetails, setShippingDetails] = useState<ShippingDetails | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [legalModal, setLegalModal] = useState<{ path: string; title: string } | null>(null);

  // 🔹 Varsayılan ödeme yöntemi: KART (Test için)
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>('card');




  // 🔹 Kupon State'leri
  const [couponCodeInput, setCouponCodeInput] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState<{code: string, discountAmount: number} | null>(null);
  const [isCouponApplying, setIsCouponApplying] = useState(false);
  const [couponError, setCouponError] = useState('');

  const handleApplyCoupon = async () => {
    if (!couponCodeInput.trim() || !orderDetails) return;
    setIsCouponApplying(true);
    setCouponError('');
    try {
        const res = await validateCoupon(couponCodeInput.trim());
        if (res && res.valid) {
            let discountAmt = 0;
            if (res.coupon.discountType === 'fixed') {
                discountAmt = res.coupon.discountValue;
            } else if (res.coupon.discountType === 'percentage') {
                discountAmt = (orderDetails.total * res.coupon.discountValue) / 100;
            }
            setAppliedCoupon({ code: res.coupon.code, discountAmount: discountAmt });
            setCouponCodeInput('');
        }
    } catch (err: any) {
        setCouponError(err.message || 'Geçersiz Kupon Kodu.');
        setAppliedCoupon(null);
    } finally {
        setIsCouponApplying(false);
    }
  };

  // --- useEffect (Veri Yükleme) ---
  useEffect(() => {
    // ... (Bu kısım aynı kalmıştır) ...
    const savedShippingJSON = sessionStorage.getItem('shippingDetails');
    if (!savedShippingJSON) {
      alert('Lütfen önce adres bilgilerinizi girin.');
      navigate('/adres-bilgileri');
      return;
    }
    setShippingDetails(JSON.parse(savedShippingJSON));

    const savedPackageJSON = localStorage.getItem('anIkareSelectedPackage');
    const savedQuantitiesJSON = localStorage.getItem('orderQuantities');
    const selectedPrintDesignsJSON = localStorage.getItem('selectedPrintDesigns');

    if (savedPackageJSON && savedQuantitiesJSON) {
      const savedPackage = JSON.parse(savedPackageJSON);
      const savedQuantities = JSON.parse(savedQuantitiesJSON);
      const selectedPrintDesigns = selectedPrintDesignsJSON
        ? JSON.parse(selectedPrintDesignsJSON)
        : null;

      const allPackages = PACKAGE_CATEGORIES.flatMap((c) => c.packages);
      const mainPackageProduct = allPackages.find((p) => p.id === savedPackage.id) || savedPackage;

      const selectedMasaDesignId: string | undefined = selectedPrintDesigns?.masaKarti?.id;
      const selectedTekYuzDesignId: string | undefined = selectedPrintDesigns?.tekYuzMasaKarti?.id;
      const selectedElDesignId: string | undefined = selectedPrintDesigns?.elKarti?.id;

      const isEko = savedPackage.id && savedPackage.id.startsWith('ekonomik');
      const freeQuantitiesMap: { [key: string]: number } = {
        'masa-karti': isEko ? 0 : (mainPackageProduct.freeTableCardQty ?? savedPackage.freeTableCardQty ?? 0),
        'tek-yuz-masa-karti': isEko ? (mainPackageProduct.freeTableCardQty ?? savedPackage.freeTableCardQty ?? 0) : 0,
        'el-karti': mainPackageProduct.freeHandCardQty ?? savedPackage.freeHandCardQty ?? 0,
        'karsilama-panosu': mainPackageProduct.freeBoardQty ?? savedPackage.freeBoardQty ?? 0,
      };

      const items = PRODUCTS
        .map((p) => {
          const orderedQuantity = savedQuantities[p.id] || 0;
          const freeQuantity = freeQuantitiesMap[p.id] || 0;
          const chargeableQuantity = Math.max(0, orderedQuantity - freeQuantity);
          
          let subtotal = chargeableQuantity * p.price;
          if (savedPackage.id === 'dugun-ozel' && p.id === 'masa-karti' && chargeableQuantity > 0) {
              const unitPrice = getCustomMasaKartiUnitPrice(chargeableQuantity);
              subtotal = Math.round(chargeableQuantity * unitPrice);
          }

          let designId: string | undefined;
          if (p.id === 'masa-karti') {
            designId = selectedMasaDesignId;
          } else if (p.id === 'tek-yuz-masa-karti') {
            designId = selectedTekYuzDesignId;
          } else if (p.id === 'el-karti') {
            designId = selectedElDesignId;
          }

          const { imageUrl, designName } = getDesignDetails(p.id, designId);

          return {
            name: p.name,
            quantity: orderedQuantity,
            subtotal,
            imageUrl,
            designName,
          };
        })
        .filter((item) => item.quantity > 0);

      const itemsSubtotal = items.reduce((acc, item) => acc + item.subtotal, 0);
      

      

      
      const shippingFee = 0;
      const total = savedPackage.price + itemsSubtotal + shippingFee;

      setOrderDetails({
        packageName: savedPackage.name,
        packagePrice: savedPackage.price,
        items,
        subtotal: savedPackage.price + itemsSubtotal,
        tax: 0,
        shippingFee,
        total,
      });
    }
  }, [navigate]);

  // --- Havale/EFT Akışı ---
  const sendOrderToBackend = async () => {
    if (!shippingDetails) return;

    const simulatedTransactionId = 'TID-' + Date.now();
    const cartId = localStorage.getItem('anIkareCartId');
    const selectedPrintDesignsJSON = localStorage.getItem('selectedPrintDesigns');
    let selectedPrintDesigns: any = null;

    if (selectedPrintDesignsJSON) {
      const base = JSON.parse(selectedPrintDesignsJSON);

      const masaDesign = base.masaKarti?.id
        ? MASA_KARTI_TASARIMLARI.find((d) => d.id === base.masaKarti.id)
        : null;

      const elDesign = base.elKarti?.id
        ? EL_KARTI_TASARIMLARI.find((d) => d.id === base.elKarti.id)
        : null;

      selectedPrintDesigns = {
        masaKarti: masaDesign
          ? {
            id: masaDesign.id,
            name: masaDesign.name,
            designImageUrl: masaDesign.designImageUrl,
            productImageUrl: masaDesign.productImageUrl,
          }
          : null,
        elKarti: elDesign
          ? {
            id: elDesign.id,
            name: elDesign.name,
            designImageUrl: elDesign.designImageUrl,
            productImageUrl: elDesign.productImageUrl,
          }
          : null,
      };
    }
    // ------------------------------------------------------------------

    try {
      const response = await fetch('/api/order/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          shippingDetails,
          transactionId: simulatedTransactionId,
          cartId,
          selectedPrintDesigns,
          orderSummary: orderDetails,
          paymentMethod: 'WIRE_TRANSFER',
          paymentStatus: 'PENDING_TRANSFER',
          couponCode: appliedCoupon?.code,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Sipariş API çağrısı başarısız oldu.');
      }

      // Başarılı kayıttan sonra onay sayfasına yönlendir
      navigate('/siparis-onay', {
        state: {
          orderDetails,
          shippingDetails,
          orderNumber: simulatedTransactionId,
          paymentMethod,
        },
      });

      // LocalStorage temizliği
      localStorage.removeItem('anIkareSelectedPackage');
      localStorage.removeItem('orderQuantities');
      localStorage.removeItem('anIkareCartId');
      localStorage.removeItem('selectedPrintDesigns');
      sessionStorage.removeItem('shippingDetails');

    } catch (error) {
      console.error('Sipariş Backend Kayıt Hatası:', error);
      const errorMessage =
        typeof error === 'object' && error !== null && 'message' in error
          ? (error as { message: string }).message
          : String(error);
      alert(`Siparişiniz kaydedilemedi. Hata: ${errorMessage}. Lütfen tekrar deneyin.`);
    } finally {
      setIsLoading(false);
    }
  };


  // OdemeSayfasi.tsx içindeki fonksiyonun son hali
  const sendPaymentToLidio = async () => {
    // ⚠️ Link akışında frontend'den kart bilgisi toplanmaz!

    setIsLoading(true);

    const cartId = localStorage.getItem('anIkareCartId');
    if (!cartId) {
      alert("Sepet ID'si bulunamadı. Lütfen tekrar deneyin.");
      setIsLoading(false);
      return;
    }

    // Link oluşturma için gerekli temel payload
    const paymentPayload = {
      shippingDetails, // Adres bilgileri
      cartId, // Sepet ID'si
      orderSummary: orderDetails, // Sipariş özeti (Tutar vb.)
      couponCode: appliedCoupon?.code,
    };

    try {
      // 2. Merkezi API Servisi ile Backend'e istek at
      // Backend'de "CreatePaymentLink" API'si çağrılacak.
      const data = await startPaymentProcess(paymentPayload);

      // 3. Backend'den gelen Ödeme Linkine YÖNLENDİRME YAP
      if (data && data.paymentLink) {

        // 💰 Başarılı: Kullanıcıyı direkt Lidio'nun Hosted Ödeme Sayfasına yönlendir
        window.location.href = data.paymentLink;

        // Yükleme durumunu kapatmıyoruz, çünkü sayfa zaten yönlendiriliyor.
      } else {
        // paymentLink gelmediyse
        alert('Ödeme linki oluşturulamadı. Lütfen tekrar deneyin.');
        setIsLoading(false);
      }

    } catch (error) {
      console.error('Lidio Link Oluşturma Hatası:', error);
      const errorInstance = error instanceof Error ? error : new Error('Bilinmeyen bir hata oluştu.');

      alert(`Ödeme başlatılamadı: ${errorInstance.message}. Lütfen tekrar deneyin.`);
      setIsLoading(false);
    }
  };

  // --- Ana Form Submit İşlemi ---
  const handleSubmitOrder = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!agreedToTerms) {
      alert('Devam etmek için Mesafeli Satış Sözleşmesi, Kullanım Koşulları ve Gizlilik Politikası ile KVKK Aydınlatma Metni\'ni onaylamanız gerekmektedir.');
      return;
    }

    if (!shippingDetails || !orderDetails) {
      alert('Sipariş bilgileri eksik. Lütfen tekrar deneyin veya adres sayfasına geri dönün.');
      return;
    }

    if (paymentMethod === 'bank_transfer') {
      setIsLoading(true);
      await sendOrderToBackend();
    } else if (paymentMethod === 'card') {
      // Kart ile ödeme akışında setIsLoading(true) fonksiyonun içinde çağrılır.
      await sendPaymentToLidio();
    }
  };


  return (
    <div className="bg-rose-50 min-h-screen">
      <SimpleHeader />

      {/* Sayfa içi Sözleşme Modal */}
      {legalModal && (
        <LegalModal
          path={legalModal.path}
          title={legalModal.title}
          onClose={() => setLegalModal(null)}
        />
      )}
      <main className="mx-auto max-w-6xl px-4 pt-24 pb-8">
        <div className="text-center mb-8 bg-rose-100/60 p-4 rounded-lg border border-rose-200">
          <h1 className="text-3xl font-extrabold text-gray-800">Ödeme</h1>
          <p className="mt-2 text-gray-600">
            Lütfen ödeme yönteminizi seçin ve siparişinizi onaylayın.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <form onSubmit={handleSubmitOrder} noValidate className="lg:col-span-2 space-y-6">

            {/* 🔹 ÖDEME YÖNTEMİ SEÇİMİ */}
            <div className="bg-white p-6 rounded-xl shadow-md border space-y-4">
              <h2 className="text-xl font-bold text-gray-800 mb-2">Ödeme Yöntemi</h2>

              <div className="space-y-3">

                {/* Havale/EFT Seçeneği */}
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="bank_transfer"
                    checked={paymentMethod === 'bank_transfer'}
                    onChange={() => setPaymentMethod('bank_transfer')}
                    className="mt-1"
                  />
                  <div>
                    <div className="font-semibold text-gray-800">Banka Havalesi / EFT</div>
                    <div className="text-sm text-gray-600">
                      Siparişinizi onayladıktan sonra IBAN'a havale/EFT yaparak ödemenizi tamamlayabilirsiniz.
                    </div>
                  </div>
                </label>

                {/* Kredi/Banka Kartı Seçeneği (Lidio) */}
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="card"
                    checked={paymentMethod === 'card'}
                    onChange={() => setPaymentMethod('card')}
                    className="mt-1"
                  />
                  <div>
                    <div className="font-semibold text-gray-800">Kredi/Banka Kartı (Lidio Güvencesiyle)</div>
                    <div className="text-sm text-gray-600">
                      3D Secure güvenceli online ödeme altyapısı ile hemen ödeme yapın.
                    </div>
                  </div>
                </label>
              </div>
            </div>

            {/* 🔹 SEÇİLEN YÖNTEM HAVALE İSE BANKA BİLGİLERİ */}
            {paymentMethod === 'bank_transfer' && (
              <div className="bg-white p-6 rounded-xl shadow-md border space-y-4">
                <h2 className="text-xl font-bold text-gray-800">Havale / EFT Bilgileri</h2>
                <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-md text-sm text-emerald-900">
                  <p className="font-semibold mb-2">
                    Lütfen aşağıdaki hesaba toplam tutarı havale/EFT olarak gönderin.
                  </p>
                  <ul className="space-y-1">
                    <li>
                      <span className="font-semibold">Banka:</span> {BANK_TRANSFER_INFO.bankName}
                    </li>
                    <li>
                      <span className="font-semibold">Hesap Adı:</span>{' '}
                      {BANK_TRANSFER_INFO.accountName}
                    </li>
                    <li>
                      <span className="font-semibold">IBAN:</span>{' '}
                      <span className="font-mono tracking-wide">
                        {BANK_TRANSFER_INFO.iban}
                      </span>
                    </li>
                  </ul>
                  <p className="mt-3">{BANK_TRANSFER_INFO.explanationNote}</p>
                  <p className="mt-1 text-xs text-emerald-800">
                    Sipariş onay ekranında da bu bilgileri göreceksiniz. Ödemeniz bize ulaştıktan
                    sonra siparişiniz manuel olarak onaylanacaktır.
                  </p>
                </div>
              </div>
            )}

            {paymentMethod === 'card' && (
              <div className="bg-white p-6 rounded-xl shadow-md border space-y-4">
                <h2 className="text-xl font-bold mb-2 text-gray-800">Online Kart ile Ödeme</h2>

                <div className="mt-4 p-4 bg-yellow-50 text-yellow-800 border border-yellow-200 rounded-md text-sm" role="alert">
                  <p className="font-semibold">Lidio Güvenceli Ödeme Sayfası</p>
                  <p className="mt-1">
                    "Siparişi Onayla ve Öde" butonuna tıkladığınızda, **Lidio'nun 3D Secure güvenceli ödeme sayfasına** yönlendirileceksiniz. Kart bilgilerinizi bu sayfada güvenle girebilirsiniz.
                  </p>
                </div>
              </div>
            )}


            {/* Sözleşme onay checkbox */}
            <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
              <label className="flex items-start gap-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={agreedToTerms}
                  onChange={(e) => setAgreedToTerms(e.target.checked)}
                  className="mt-1 w-4 h-4 accent-rose-500 flex-shrink-0 cursor-pointer"
                />
                <span className="text-sm text-gray-600 leading-relaxed">
                  <button type="button" onClick={() => setLegalModal({ path: '/mesafeli-satis', title: 'Mesafeli Satış Sözleşmesi' })} className="text-rose-600 font-medium hover:underline">Mesafeli Satış Sözleşmesi</button>,{' '}
                  <button type="button" onClick={() => setLegalModal({ path: '/kosullar', title: 'Kullanım Koşulları' })} className="text-rose-600 font-medium hover:underline">Kullanım Koşulları</button>{' '}ve{' '}
                  <button type="button" onClick={() => setLegalModal({ path: '/gizlilik-politikasi', title: 'Gizlilik Politikası ve KVKK Aydınlatma Metni' })} className="text-rose-600 font-medium hover:underline">Gizlilik Politikası ve KVKK Aydınlatma Metni</button>'ni okudum, onaylıyorum.
                </span>
              </label>
            </div>

            <Button
              type="submit"
              size="lg"
              className="w-full bg-[#E45078] hover:bg-rose-600 text-white text-lg disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading || !shippingDetails || !orderDetails || !agreedToTerms}
            >
              {isLoading
                ? (paymentMethod === 'card' ? 'Ödeme Başlatılıyor...' : 'Sipariş Kaydediliyor...')
                : 'Siparişi Onayla ve Öde'}
            </Button>
          </form>

          <div className="lg:col-span-1 space-y-6">
            <OrderSummaryCard 
                orderDetails={orderDetails} 
                couponCode={appliedCoupon?.code} 
                discountAmount={appliedCoupon?.discountAmount} 
            />

            {/* İNDİRİM KODU ALANI */}
            <div className="bg-white p-6 rounded-xl shadow-md border text-sm">
                <h3 className="font-bold text-gray-800 mb-3">İndirim Kuponu</h3>
                {appliedCoupon ? (
                    <div className="flex justify-between items-center bg-emerald-50 text-emerald-700 p-3 rounded-md border border-emerald-200">
                        <div>
                            <strong>{appliedCoupon.code}</strong> uygulandı.
                        </div>
                        <button type="button" onClick={() => setAppliedCoupon(null)} className="text-red-500 font-bold hover:underline">Kaldır</button>
                    </div>
                ) : (
                    <div>
                        <div className="flex gap-2">
                            <input 
                                type="text" 
                                placeholder="Kupon Kodunuz" 
                                value={couponCodeInput}
                                onChange={(e) => setCouponCodeInput(e.target.value.toUpperCase())}
                                className="border border-gray-300 rounded-md p-2 flex-grow focus:outline-none focus:ring-1 focus:ring-rose-500"
                            />
                            <button 
                                type="button" 
                                onClick={handleApplyCoupon}
                                disabled={isCouponApplying || !couponCodeInput}
                                className="bg-gray-800 text-white px-4 py-2 rounded-md hover:bg-gray-700 disabled:opacity-50"
                            >
                                {isCouponApplying ? '...' : 'Uygula'}
                            </button>
                        </div>
                        {couponError && <p className="text-red-500 mt-2 text-xs">{couponError}</p>}
                    </div>
                )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}